import { Component, OnInit, Input, Inject } from '@angular/core';
import { RopeShovelService } from '../../rope-shovel.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationsService } from 'angular2-notifications';
import { EditPhotoComponent } from '../../../../shared/components/edit-photo/edit-photo.component';
import { MeasurementPointPhotoModel, MandatoryCompartTypePhotoModel } from '../../models/rope-shovel.model';
import { DeleteConfirmationDialogComponent } from '../delete-confirmation-dialog/delete-confirmation-dialog.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'view-photo',
  templateUrl: './view-photo.component.html',
  styleUrls: ['./view-photo.component.scss']
})
export class ViewPhotoComponent implements OnInit {
  photoType: string;
  photoId: number;
  photoTitle: string;
  photoData: string;
  photoComment: string;

  isMP: boolean = false;
  isMandatoryPhoto: boolean = false;
  isAdditionalPhoto: boolean = false;

  isDeleteAllowed: boolean = false;
  viewonly:boolean=false;
  additioanl:boolean=false;
  constructor(private _service: RopeShovelService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _sanitizer: DomSanitizer,
    private _notify: NotificationsService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<ViewPhotoComponent>) { }

  ngOnInit() {
    this.photoType = this.data.photoType;
    this.photoId = this.data.photoId;

    switch (this.photoType) {
      case 'mandatory':
        this.loadMandatoryPhoto();
        this.isMandatoryPhoto = true;
        this.additioanl=false;
        break;
      case 'measurementpoint':
        this.loadMeasurementPointPhoto();
        this.isMP = true;
        this.additioanl=false;

        break;
      case'measurementpoint_Img':
        this.viewonly = true;
        this.photoData = this.data.img;
        this.additioanl=false;

        break;
      case'additioanl':
        this.viewonly = true;
        this.photoData = this.data.img;
        this.additioanl=true;
       // this.isDeleteAllowed = false;
        this.isDeleteAllowed = true;
       this.isAdditionalPhoto=true
        console.log("image__", this.photoData)
        break;
    }
//if(this.additioanl==false){
  this._service.hasPermissionToDeletePhoto(this.photoId).subscribe(r => {
    if (r) {
        this.isDeleteAllowed = true;
    }
});
//}
   
  }

  getImage(image: string) {
    if (image.startsWith("https://"))
      return image.replace('Thumbnail_M','');
    else
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
  }

  loadMeasurementPointPhoto() {
    this._service.getMeasurementPointPhoto(this.photoId).subscribe(p => {
      this.photoTitle = p.Title;
      this.photoData = p.Photo;
      this.photoComment = p.Comment;
    });
  }

  loadMandatoryPhoto() {
    this._service.getMandatoryCompartPhotoAsync(this.photoId).subscribe(p => {
      this.photoTitle = p.Title;
      this.photoData = p.Photo;
      this.photoComment = p.Comment;
    });
  }

  openEditPhoto() {
      let editPhotoModalRef = this.dialog.open(EditPhotoComponent, {
        width: '1024px',
        height: '768px',
        data: { photo: this.photoData }
      });
      editPhotoModalRef.afterClosed().subscribe(res => {
        if (res != null) {
          this.photoData = res.photo;
          switch (this.photoType) {
            case 'mandatory':
              this.uploadMandatoryCompartTypePhoto(res.photo);
              break;
            case 'measurementpoint':
              this.uploadMeasurementPointPhoto(res.photo);
              break;
            case 'additioanl':
              this.UploadAdditonalPhoto(res.photo);
              break;
          }
        }
      });
  }

  uploadMandatoryCompartTypePhoto(p: string) {
    this._notify.info('Uploading', 'Uploading your photo now...');

    let uploadModel = new MandatoryCompartTypePhotoModel(-1, -1, p, this.photoId, -1);
    this._service.uploadCompartMandatoryPhoto(uploadModel).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Uploaded', r.m_Item2);
      } else {
        this._notify.error('Failed', r.m_Item2);
        console.log(r);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to upload photo. Please contact TrackTreads support. ');
      console.log(err);
    });
  }

  uploadMeasurementPointPhoto(p: string) {
    this._notify.info('Uploading', 'Uploading your photo now...');
    let uploadModel = new MeasurementPointPhotoModel(this.photoId, p);
    this._service.uploadMeasurementPointPhoto(uploadModel).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Uploaded', r.m_Item2);
      } else {
        this._notify.error('Failed', r.m_Item2);
        console.log(r);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to upload photo. Please contact TrackTreads support. ');
      console.log(err);
    });
  }

  showDeletePhotoConfirmationDialog() {
      let confirmationModalRef = this.dialog.open(DeleteConfirmationDialogComponent, {
          width: '480px',
          height: '240px'
      });
      confirmationModalRef.afterClosed().subscribe(r => {
          if ((r.data != null) && (r.data.goAhead)) {
              this.deletePhoto();
          }
      });   
  }

  deletePhoto() {
    console.log("this.isAdditionalPhoto", this.isAdditionalPhoto)
      if (this.isMP) {
          this._service.deleteMeasurementPointPhoto(this.photoId).subscribe(r => {
              if (r.m_Item1) {
                  this._notify.success('Deleted Image', r.m_Item2);
                  this.dialogRef.close({ data: { id: this.photoId, isDeleted: r.m_Item1 } });
              } else {
                  this._notify.error('Failed', r.m_Item2);
              }
          });
      } else if (this.isMandatoryPhoto) {
          this._service.deleteMandatoryPhoto(this.photoId).subscribe(r => {
              if (r.m_Item1) {
                  this._notify.success('Deleted Image', r.m_Item2);
                  this.dialogRef.close({ data: { id: this.photoId, isDeleted: r.m_Item1 } });
              } else {
                  this._notify.error('Failed', r.m_Item2);
              }
          });
      } else if (this.isAdditionalPhoto) {
        this._service.DeleteAdditionalPhoto(this.photoId).subscribe(r => {
            if (r.m_Item1) {
                this._notify.success('Deleted Image', r.m_Item2);
                this.dialogRef.close({ data: { id: this.photoId, isDeleted: r.m_Item1 } });
            } else {
                this._notify.error('Failed', r.m_Item2);
            }
        });
    }
  }



  UploadAdditonalPhoto(p: string) {
    this._notify.info('Uploading', 'Uploading your photo now...');
    let uploadModel = new MeasurementPointPhotoModel(this.photoId, p);
    this._service.UploadAdditonalPhoto(uploadModel).subscribe(r => {
      if (r.m_Item1) {
        this._notify.success('Uploaded', r.m_Item2);
      } else {
        this._notify.error('Failed', r.m_Item2);
        console.log(r);
      }
    }, err => {
      this._notify.error('Failed', 'Unable to upload photo. Please contact TrackTreads support. ');
      console.log(err);
    });
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
